export enum SwimmingPoolType {
  Inground = 'Inground',
  AboveGround = 'Above Ground',
}
